import { useEffect } from "react";
import type { ValidationCause } from "@tanstack/react-form";
import type { RegisterStepSave, StepKeys } from "./types";

type RegisterableForm = {
  state: {
    isValid: boolean;
    isSubmitting: boolean;
    isValidating: boolean;
    isDirty: boolean;
    isSubmitted: boolean;
  };
  handleSubmit: () => Promise<unknown> | unknown;
  validateAllFields: (cause: ValidationCause) => Promise<unknown>;
};

type UseRegisterStepSaveArgs = {
  stepKey?: StepKeys;
  registerStepSave?: RegisterStepSave;
  form: RegisterableForm;
};

export const useRegisterStepSave = ({
  stepKey,
  registerStepSave,
  form,
}: UseRegisterStepSaveArgs) => {
  useEffect(() => {
    if (!stepKey || !registerStepSave) {
      return;
    }

    return registerStepSave(stepKey, () => ({
      stepKey,
      isDirty: form.state.isDirty,
      isInvalid: !form.state.isValid,
      isSaving: form.state.isSubmitting,
      isValidating: form.state.isValidating,
      isSubmitted: form.state.isSubmitted,
      validateAllFields: async () => {
        await form.validateAllFields("submit");
      },
      flush: async () => {
        const formState = form.state;
        if (
          formState.isSubmitting ||
          (formState.isSubmitted && !formState.isDirty) ||
          !formState.isValid
        ) {
          return;
        }

        await form.handleSubmit();
      },
    }));
  }, [form, registerStepSave, stepKey]);
};
